export var CorrelationExportOption;
(function (CorrelationExportOption) {
    CorrelationExportOption["NO_POINTS"] = "no_points";
    CorrelationExportOption["WITH_POINTS"] = "with_points";
    CorrelationExportOption["WITH_POINTS_AND_LEGEND"] = "with_points_and_legend";
})(CorrelationExportOption || (CorrelationExportOption = {}));
